import { useEffect, useState } from "preact/hooks";
import { getUpdateStatus, subscribeUpdateStatus, type UpdateStatus } from "../pwa/status";

export function useUpdateStatus(): UpdateStatus {
  const [status, setStatus] = useState(getUpdateStatus());
  useEffect(() => subscribeUpdateStatus(setStatus), []);
  return status;
}

/** The "Update available" indicator (issue #3): a tag that leads to the About section, shown once an update is staged or downloading. */
export function UpdateIndicator({ link = true }: { link?: boolean }) {
  const status = useUpdateStatus();
  let text: string | null = null;
  if (status.phase === "ready") text = `Update to ${status.staged.release} ready`;
  else if (status.phase === "downloading") text = `Downloading ${status.release || "an update"}…`;
  else if (status.phase === "shell-pending") text = `Update to ${status.release} downloading`;
  if (!text) return null;
  return link ? <a href="#/" class="tag open update-indicator" onClick={() => setTimeout(() => document.getElementById("about")?.scrollIntoView({ block: "start" }), 50)}>{text}</a> : <span class="tag open update-indicator">{text}</span>;
}
